import { createClickedSegmentEvent } from '../../Utilities/Instrumentation/Impressions/impressionSegmentEvents'
import styles from './CalloutCard.module.scss'

import React from 'react'

import ClassNames from 'classnames'

import Button from 'Molecules/Button'

import Card from 'Atoms/Card'
import Typography from 'Atoms/Typography'

const CalloutCard = ({
  title,
  subtitle,
  supertitle,
  noSubtitleOnMobile = false,
  image,
  imageLoading,
  button,
  bottomLinks,
  appName,
  className,
  darkened,
  imageOpacity,
  noMargin,
  center,
}) => {
  const handleOnClick = () => {
    if (button?.url && typeof window !== 'undefined') {
      window.location.href = button.url
    }
  }

  return (
    <div className={ClassNames(styles.cardWrapper, className ?? '')}>
      <Card
        layer={0}
        fill
        fillPanelHeight
        noMargin={noMargin}
        noPadding
        image={image}
        onClick={handleOnClick}
        imageLoading={imageLoading}
        invert
        imageOpacity={imageOpacity ?? (darkened ? 0.8 : null)}
      >
        <div
          className={ClassNames(
            styles.calloutContent,
            center ? styles.centerContent : '',
            !button?.url ? styles.cursor : '',
          )}
        >
          {supertitle && (
            <Typography tone={'contrast'} className={styles.supertitle} size={1}>
              {supertitle}
            </Typography>
          )}
          {title && (
            <Typography font={'bold'} tone={'contrast'} className={styles.text} size={2}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              font={'regular'}
              tone={'contrast'}
              size={1.5}
              className={noSubtitleOnMobile ? ClassNames(styles.hideSubtitle, styles.subtitle) : styles.subtitle}
            >
              {subtitle}
            </Typography>
          )}
          {button?.url && button?.text && (
            <Button
              brand={'secondary'}
              size={button.size ?? 'small'}
              href={button.url}
              segmentEvent={createClickedSegmentEvent('CalloutCardButton')}
              className={styles.button}
              text={button.text}
              testingName={`calloutCard_${title}_primaryButton_${button.text}`}
            />
          )}
        </div>
        {bottomLinks && (
          <div className={styles.bottomLinksWrapper}>
            {(bottomLinks || []).map((link) => {
              return (
                <Button
                  key={`callout_card_bottomLink_${link.text}`}
                  href={link.url}
                  className={styles.bottomLink}
                  text={link.text}
                  segmentEvent={createClickedSegmentEvent('CalloutCardBottomLink')}
                  size={'small'}
                  brand={'secondarypalette_black'}
                  testingName={`calloutCard_${title}_secondaryButton_${link?.text}`}
                />
              )
            })}
          </div>
        )}
      </Card>
    </div>
  )
}

export default CalloutCard
